module.exports = __webpack_public_path__ + "img/l1.0952164c.png";